import { getClientDeviceType, getDealAndObjectType } from '../../../../../shared/utils';
import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackSendClick = (isPaid, isShortForm) => {
  const siteType = getClientDeviceType();

  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'Click',
    label: isPaid ? 'place&pay' : 'place',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        form_type: isShortForm ? 'short' : 'full'
      }
    },
  });
};

export const trackPublishByMoneyFailed = ({ isShortForm, offerId }) => {
  ca('eventSite', {
    name: 'oldEvent',
    category: adAnalyticsCategory,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'not_enough_money',
    page: {
      pageType: 'AddForm',
      siteType: getClientDeviceType(),
      extra: {
        form_type: isShortForm ? 'short' : 'full',
      },
    },
  });
};

export const trackTryToSend = (isShortForm, category) => {
  const { dealType, objectType } = getDealAndObjectType(category);

  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: isShortForm ? 'tab_short_form_try_to_send' : 'tab_full_form_try_to_send',
    label: `${dealType}/${objectType}`
  });
};
